/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Summary card for an expert, returned by the matching and last-session tools and
 * rendered by the client during the booking flow.
 */
export interface AiGuideBotModelsExpertCardData {
  /** Short label on the card (e.g. "Best Match" or "Recommended"). */
  caption?: null | string;
  /** Short profile description used to introduce the expert. */
  description?: null | string;
  /** Expert's first name, shown on the card and in confirmations. */
  expertFirstName?: null | string;
  /** Unique identifier of the expert, used as the key for availability and booking. */
  expertId?: null | string;
  /** Expert's last name. */
  expertLastName?: null | string;
  /** URL of the expert's profile image. */
  imageUrl?: null | string;
  /** Optional client-side selection key, set when the card is returned as a choice option. */
  key?: null | string;
  /** Language codes the expert can deliver sessions in. */
  languageCodes: string[];
  /**
   * The expert's MOU URL handle. The client builds the in-app profile path from this, which keeps
   * the link on the domain the user is already authenticated on and in the locale of their UI.
   */
  personalUrlHandle?: null | string;
  /**
   * Absolute profile URL, built from the account-app domain the API is configured with for the
   * "en" locale, so it is not necessarily the domain this user is signed in to. Superseded by
   * PersonalUrlHandle and kept only so chat messages persisted before that field existed still
   * render a link (AI-156). New clients must build the profile path from PersonalUrlHandle.
   */
  profileUrl?: null | string;
  /** Expert's specialisation, localised to the requested language. */
  specialisation?: null | string;
  /** Comma-separated list of the expert's top topics, localised. */
  topics?: null | string;
}

/** Input for content lookup when the user asks for wellbeing material. */
export interface AiGuideBotModelsSearchContentRequest {
  /**
   * Optional content type filter.
   * Set this only when the user explicitly asks for a format (for example, article or video).
   */
  contentType?: null | string;
  /**
   * Language code used to filter results, such as `en-GB` or `nl-NL`.
   * Keep this aligned with the user's mentioned language.
   */
  language: string;
  /**
   * Zero-based page number for pagination.
   * Start with `0` and increment only if more results are needed.
   * @format int32
   */
  pageIndex: number;
  /**
   * Main user topic or question to search for.
   * Prefer the user's exact wording from the latest turn.
   */
  topic: string;
  /**
   * Id of the end user the search is performed for, used by the service-authenticated v2
   * endpoint. Required for content that is gated per user, such as audio exercises; omit it and
   * that content is left out of the results.
   * The v1 endpoint ignores this and takes the user from the caller's own bearer token.
   */
  userId?: null | string;
}

/** Request model for patching a conversation's mutable fields. */
export interface AiGuideBotModelsUpdateConversationRequest {
  /** The new conversation title. */
  title: string;
}

/** Request model for updating an existing conversation message's metadata. */
export interface AiGuideBotModelsUpdateMessageRequest {
  /** Optional message-type discriminator (e.g. a choice-prompt type). */
  messageType?: null | string;
  /** Optional metadata key/value pairs to merge onto the message (e.g. marking a choice as responded). */
  metadata?: null | object;
  /** Optional structured payload associated with the message type. */
  payload?: null;
  /** Optional replacement text for the message. */
  text?: null | string;
}

/**
 * Body of a conversation-starter answer: which starter was completed, the sentence the person completed it with,
 * and the language the homepage showed it in. Mirrors the AI Coach's contract field-for-field so it forwards
 * without remapping.
 */
export interface AiGuideBotRequestsAnswerConversationStarterRequest {
  /** The starter's id on the web (`work`, `conversations`, `movement`, `sleep` or `starting`). */
  kind: OpenUpAiCoachApiContractsConversationStarterKind;
  /** The language the homepage showed the starter in: `en`, `nl`, `es`, `de` or `fr`. The coach answers in it. */
  language: OpenUpAiCoachApiContractsConversationLanguage;
  /**
   * The whole sentence, the starter's beginning completed with the ending picked or the words typed, exactly as
   * the coach should read it. Trimming and length (1-2000 chars) are enforced by the AI Coach.
   */
  userMessage: string;
}

/**
 * Contains all validated details required to finalize a session booking.
 * Ensure all fields are derived from the current conversation state and confirmed by the user before submission.
 */
export interface AiGuideBotRequestsBookSessionRequestV2 {
  /** The unique identifier of the selected expert for this session. */
  expertId: string;
  /** Preferred session language code (e.g., 'en-US' or 'nl-NL') as confirmed by the user. */
  language: string;
  /**
   * Chosen UTC start time for the session, picked from available expert slots.
   * @format date-time
   */
  sessionDateTime: string;
  /** Session type (e.g., 'general' or 'physical-wellbeing') that matches the user's need. */
  sessionType: string;
  /** The user's preferred time zone used for confirming the final slot timing. */
  timezone: string;
  /** The end user the session is booked for. Supplied explicitly by the AI Coach (sourced from the request it received) rather than derived from a forwarded user token, under service-to-service auth (security-enhancements.md s6c). */
  userId: string;
}

/** Body of opening an answered conversation starter into a conversation ("Guide me through this"). */
export interface AiGuideBotRequestsOpenConversationStarterRequest {
  /**
   * The starter's topic in the homepage's language. It titles the conversation in history and names the
   * "From your starting point" card above the first message. Trimming and length (1-512 chars) are enforced by
   * the AI Coach.
   */
  topic: string;
}

/**
 * Body of a chat-bot streaming request: the full client-owned message history plus
 * the caller's time zone, forwarded to the AI Coach.
 */
export interface AiGuideBotRequestsSendConversationMessageRequest {
  /** The user's time zone (IANA or Windows), used to localise session times. */
  clientTimezone: string;
  /** The conversation messages, sent in full by the client on every turn. */
  messages: AiGuideBotRequestsSendConversationMessageRequestMessage[];
}

/** A single message within a AiGuideBot.Requests.SendConversationMessageRequest. */
export interface AiGuideBotRequestsSendConversationMessageRequestMessage {
  /**
   * When the message was created on the client.
   * @format date-time
   */
  createdAt: string;
  /** Client-owned message identifier (e.g. the Vercel AI SDK message id). */
  id: string;
  /**
   * The Vercel AI SDK UI message metadata object (e.g. the user's device context under
   * `clientInfo` for usage reporting). Loosely typed and forwarded verbatim to the
   * AI Coach; only the client (producer) and the AI Coach (consumer) interpret its shape.
   */
  metadata?: null;
  /**
   * The message content as Vercel AI SDK UI message parts (e.g. `text` and
   * `data-*` parts). Loosely typed because the shape is owned by the client SDK and
   * forwarded verbatim to the AI Coach.
   */
  parts: any[];
  /** Message role: `user` or `assistant`. */
  role: OpenUpAiCoachApiContractsApiChatMessageRole;
}

/**
 * Contains the details needed to submit a help desk support request on behalf of the user.
 * The AI Coach generates the conversation summary; this endpoint only emails it to the support team.
 * Only call this after the user has explicitly confirmed they want their request submitted.
 */
export interface AiGuideBotRequestsSubmitHelpDeskRequestV2 {
  /** The conversation summary generated by the AI Coach, emailed verbatim to the support team. */
  summary: string;
  /** The end user the request is submitted on behalf of. Supplied explicitly by the AI Coach (sourced from the request it received) rather than derived from a forwarded user token, under service-to-service auth (security-enhancements.md s6c). */
  userId: string;
}

/**
 * Body of a message-feedback request: how the user rated one assistant message,
 * the preset reasons they selected, and any free text they typed.
 * Mirrors the AI Coach's feedback contract field-for-field so it forwards without remapping.
 */
export interface AiGuideBotRequestsSubmitMessageFeedbackRequest {
  /**
   * Optional free text the user typed about the reply. Length (max 1000 chars) is enforced by
   * the AI Coach.
   */
  freeText?: null | string;
  /**
   * The preset reason values the user selected (e.g. `still_stuck`), not their translated
   * labels — the AI Coach stores these in the score metadata, where short stable values are what
   * makes the feedback groupable. Bounds (max 10, each 1-64 chars) are enforced by the AI Coach.
   */
  reasons: string[];
  sentiment: OpenUpAiCoachApiContractsMessageFeedbackRequestSentiment;
}

export interface AiGuideBotResponsesAnswerConversationStarterResponse {
  /**
   * What the web needs to draw the crisis card in place of a starter's note: the coach's own line for above the card,
   * or null when there is none and the web shows its own copy. The phone numbers are the web's, never model output.
   */
  emergency?: AiGuideBotResponsesEmergencyNoteResponse | null;
  messageType: string;
  starter?: AiGuideBotResponsesConversationStarterResponse | null;
}

/**
 * Confirms the details of a successfully booked session.
 * Use this data to provide a final summary and reassure the user that their appointment is scheduled.
 */
export interface AiGuideBotResponsesBookSessionResponse {
  /**
   * The unique identifier for the booked consult.
   * @format int32
   */
  consultId: number;
  /** The unique identifier of the assigned expert. */
  expertId: string;
  /** Optional URL for the expert's profile picture to enhance the confirmation message. */
  expertImageUrl?: null | string;
  /** The first name of the expert for the booked session. Use this to confirm the expert to the user. */
  expertName: string;
  /**
   * The expert's MOU URL handle. The client builds the in-app profile path from this, which keeps the link on
   * the domain the user is already authenticated on. Nullable so the field stays optional in the generated
   * clients and the API can deploy ahead of them.
   */
  expertPersonalUrlHandle?: null | string;
  /**
   * Absolute profile URL, built from the account-app domain the API is configured with for the "en" locale, so it
   * is not necessarily the domain this user is signed in to. Superseded by ExpertPersonalUrlHandle
   * and kept only so confirmations persisted before that field existed still render a link (AI-156).
   */
  expertProfileUrl: string;
  /**
   * The confirmed UTC start time for the session. Use this to inform the user of their appointment time.
   * @format date-time
   */
  sessionDateTime: string;
  /** The language confirmed for the session. */
  sessionLanguage: string;
  /** The confirmed session type. */
  sessionType: string;
  /** The user's preferred time zone for the booking. */
  timezone: string;
}

/** Whether the current user has consented to use the AI coach. */
export interface AiGuideBotResponsesCoachConsentResponse {
  /**
   * True once the user holds any conversation or any homepage conversation starter: the AI Coach derives consent from
   * use and stores nothing for it.
   */
  hasConsented: boolean;
}

export interface AiGuideBotResponsesConversationMessageResponseV2 {
  /** @format date-time */
  createdAt: string;
  id: string;
  metadata?: null | object;
  parts: any[];
  role: string;
}

export interface AiGuideBotResponsesConversationStarterResponse {
  /** @format uuid */
  conversationId?: null | string;
  /** @format date-time */
  createdAt: string;
  followupQuestion: string;
  /** @format uuid */
  id: string;
  kind: string;
  language: string;
  reply: string;
  tip: string;
  userMessage: string;
}

/**
 * What the web needs to draw the crisis card in place of a starter's note: the coach's own line for above the card,
 * or null when there is none and the web shows its own copy. The phone numbers are the web's, never model output.
 */
export interface AiGuideBotResponsesEmergencyNoteResponse {
  text?: null | string;
}

/**
 * Provides information about the user's most recent completed session.
 * Use this to suggest the same expert for follow-up appointments or to acknowledge their history with OpenUp.
 */
export interface AiGuideBotResponsesGetLastSessionResponse {
  /** Indicates if a completed session was found whose expert can still be booked for this session type. If false, treat the user as new to this session type. */
  hasPreviousSession: boolean;
  /** The details of the expert from the last session. Use this to offer a 'book again' option with a known face. */
  previousSessionExpert?: AiGuideBotModelsExpertCardData | null;
}

export interface AiGuideBotResponsesInsightCardResponse {
  /** @format uuid */
  conversationId?: null | string;
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format uuid */
  id: string;
  title: string;
  type: string;
}

/** One question and what the person answered. */
export interface AiGuideBotResponsesLatestVitalityCheckInQuestionResponse {
  /** The option labels chosen or the text written, truncated past a length bound; never empty. */
  answers: string[];
  /**
   * How many options SelectedIndex counts out of; null exactly when it is.
   * @format int32
   */
  optionCount?: null | number;
  /** The question text as the person read it. */
  question: string;
  /**
   * The 0-based position of the single chosen option, or null when there is none.
   * @format int32
   */
  selectedIndex?: null | number;
}

/**
 * One check-in, with the same property names as the `openup.user.vitality-check-in-completed.v1` event data,
 * less `userId`.
 */
export interface AiGuideBotResponsesLatestVitalityCheckInResponse {
  /**
   * The sitting; for a check-in stored before AI-285, the smallest row id of the sitting.
   * @format uuid
   */
  checkInId: string;
  /** Per-theme results; never empty. */
  checkinResults: AiGuideBotResponsesLatestVitalityCheckInThemeResponse[];
  /**
   * When the check-in was completed, UTC.
   * @format date-time
   */
  completedAt: string;
  /** The two-letter code of the questionnaire edition filled in, such as `nl`. */
  language: string;
}

/** One theme's result. */
export interface AiGuideBotResponsesLatestVitalityCheckInThemeResponse {
  /** The score band: `Low`, `Medium` or `High`. */
  category: string;
  /** The localized copy for that band, or null when there is none. */
  description?: null | string;
  /** The publishable, answered questions behind the score, in the order asked; can be empty. */
  questions: AiGuideBotResponsesLatestVitalityCheckInQuestionResponse[];
  /**
   * The theme's 0-100 score, higher is better.
   * @format double
   */
  score: number;
  /** The configured theme key, such as `Stress`. */
  theme: string;
}

/** One client-visible dossier section. */
export interface AiGuideBotResponsesSessionNotesHistoryNoteResponse {
  /** The expert's note text. */
  answer: string;
  /** The dossier question key. */
  question: string;
}

/**
 * One consult's client-visible session notes, with the same property names as the
 * `openup.sessions.session-notes-available.v1` event data, less `userId`.
 */
export interface AiGuideBotResponsesSessionNotesHistoryResponse {
  /**
   * When the notes originally became available to the client, UTC.
   * @format date-time
   */
  availableAt: string;
  /**
   * The consult the notes belong to.
   * @format int32
   */
  consultId: number;
  /** User id of the expert who wrote the notes. */
  expertId: string;
  /** The consult's session language code (such as `nl`), or null when it carries none. */
  language?: null | string;
  /** The client-visible note sections (reasonBook, then sessionDiscussed); never empty. */
  notes: AiGuideBotResponsesSessionNotesHistoryNoteResponse[];
}

/** One opted-in user and their latest check-in. */
export interface AiGuideBotResponsesUserLatestVitalityCheckInResponse {
  /** Their latest check-in from the last 365 days. */
  checkIn: AiGuideBotResponsesLatestVitalityCheckInResponse;
  /** The user who completed the check-in. */
  userId: string;
}

export interface AiGuideBotResponsesUserLatestVitalityCheckInResponsePaginated {
  data: AiGuideBotResponsesUserLatestVitalityCheckInResponse[];
  pagination: ResponsePagination;
}

/** One opted-in user and their consults' client-visible notes, oldest first. */
export interface AiGuideBotResponsesUserSessionNotesResponse {
  /** Their consults from the last 365 days with client-visible notes; never empty. */
  sessionNotes: AiGuideBotResponsesSessionNotesHistoryResponse[];
  /** The user (the consults' client). */
  userId: string;
}

export interface AiGuideBotResponsesUserSessionNotesResponsePaginated {
  data: AiGuideBotResponsesUserSessionNotesResponse[];
  pagination: ResponsePagination;
}

export interface ConfirmUserParams {
  /** User verification code */
  token?: string;
}

export interface FindMatchingExpertsParams {
  /** Optional. Returns only experts of this gender, using the portal's values (e.g. female); compared in lower case. Experts with no gender recorded are excluded when set. */
  gender?: string;
  /** Language code used to filter experts and localize returned fields. */
  language?: string;
  /** Short user summary used for semantic matching against expert profiles. */
  matchingCriteria?: string;
  /**
   * Optional. True returns only experts who are medical doctors; false or missing applies no filter.
   * @default false
   */
  medicalDoctor?: boolean;
  /**
   * Optional. Minimum years of experience, 5 or 10: 5 returns experts with 5 to 10 or more than 10 years, 10 returns experts with more than 10 years. Experts with no experience recorded are excluded when set.
   * @format int32
   */
  minimumExperience?: number;
  /** Session type used to restrict matches to relevant experts. */
  sessionType?: string;
}

export interface GetAudioListParams {
  audience?: string;
  contentGroups?: string[];
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
}

export interface GetAutocompleteParams {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetBookmarkedContentsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetContentsV2Params {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetConversationsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetExpertFirstAvailableTimeSlotsParams {
  /** Selected expert identifier from the current booking flow. */
  expertId: string;
  /**
   * The earliest UTC date and time to start searching for available slots. Use this if the user requests availability after a specific moment.
   * @format date-time
   */
  fromDateTime?: string;
  /** User's time zone (Windows or IANA) used to localize returned slot times. */
  userTimeZone?: string;
}

export interface GetLastCompletedSessionParams {
  /** Session type to match when selecting the last completed session. */
  sessionType?: string;
  userId?: string;
}

export interface GetManagerMixedContentsParams {
  excludeContentTypes?: string[];
  languageCode?: string;
  topics?: string[];
  /** @format int32 */
  totalCount?: number;
}

export interface GetMixedContentsV2Params {
  languageCode?: string;
  /** @format int32 */
  totalCount?: number;
}

export interface GetPagedMixedContentsV2Params {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetSessionNotesParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  /** Restricts the result to this user; omit it for every opted-in user. */
  userId?: string;
}

export interface GetShortsParams {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetVitalityCheckInsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  /** Restricts the result to this user; omit it for every opted-in user. */
  userId?: string;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  detail?: null | string;
  instance?: null | string;
  /** @format int32 */
  status?: null | number;
  title?: null | string;
  type?: null | string;
  [key: string]: any;
}

export interface ModelsAiSearchFaqSearchResultItem {
  answer?: null | string;
  question?: null | string;
}

export interface ModelsContentsContent {
  coverImage: ModelsCoverImage;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  languageCode?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  /** @format int32 */
  order: number;
  orientation?: null | string;
  /** @format int64 */
  parentId?: null | number;
  provider?: null | string;
  slug?: null | string;
  status?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  translations?: null | any[];
  type?: null | string;
  url?: null | string;
  userGroups?: null | any[];
  videoFormat?: null | string;
}

export interface ModelsCoverImage {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

export enum ModelsDtosSearchSearchResultType {
  Spaces = "Spaces",
  Experts = "Experts",
  Videos = "Videos",
  Articles = "Articles",
  Shorts = "Shorts",
  Audio = "Audio",
  All = "All",
}

/** @format int32 */
export enum ModelsDtosShortsMode {
  Include = "Include",
  Exclude = "Exclude",
  Only = "Only",
}

/** @format int32 */
export enum ModelsRequestSource {
  IsClientApp = "IsClientApp",
  IsDashboard = "IsDashboard",
  IsMobileiOS = "IsMobileiOS",
  IsMobileAndroid = "IsMobileAndroid",
  IsCustomerSuccess = "IsCustomerSuccess",
  IsSpaces = "IsSpaces",
}

export interface ModelsUserPreference {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export interface OpenStaticCardConversationParams {
  /**
   * The static card's key, as the web's `STATIC_OPENERS` ids spell it (for example `money-stress`).
   * @maxLength 64
   * @pattern ^[a-z0-9-]+$
   */
  cardKey: string;
  /**
   * The language the deck showed the card in: `en`, `nl`, `de`, `fr` or `es`, with or without a region (for example `en-GB`).
   * @pattern ^(en|nl|de|fr|es)(-[A-Za-z]{2})?$
   */
  languageCode: string;
}

export enum OpenUpAiCoachApiContractsApiChatMessageRole {
  User = "User",
  Assistant = "Assistant",
}

export interface OpenUpAiCoachApiContractsConversation {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedAt?: null | string;
  title?: null | string;
  [key: string]: any;
}

export enum OpenUpAiCoachApiContractsConversationLanguage {
  En = "En",
  Nl = "Nl",
  Es = "Es",
  De = "De",
  Fr = "Fr",
}

export enum OpenUpAiCoachApiContractsConversationStarterKind {
  Work = "Work",
  Conversations = "Conversations",
  Movement = "Movement",
  Sleep = "Sleep",
  Starting = "Starting",
}

export interface OpenUpAiCoachApiContractsConversationSummary {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedAt?: null | string;
  title?: null | string;
  [key: string]: any;
}

export interface OpenUpAiCoachApiContractsListConversationsResponse {
  data: OpenUpAiCoachApiContractsConversationSummary[];
  pagination: OpenUpAiCoachApiContractsPageInfo;
  [key: string]: any;
}

export enum OpenUpAiCoachApiContractsMessageFeedbackRequestSentiment {
  Positive = "Positive",
  Negative = "Negative",
}

export interface OpenUpAiCoachApiContractsPageInfo {
  hasNext: boolean;
  hasPrevious: boolean;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  [key: string]: any;
}

export interface ProviderChallengePayload {
  /** E.g. Google */
  provider?: string;
  /** The OpenUp URL responsible for handling the login response */
  redirectUrl?: string;
}

export interface RequestBookSlotRequestV2 {
  expertId?: null | string;
  expertIdsToExclude?: null | any[];
  recaptchaToken?: null | string;
  sessionContext?: null | string;
  tags: RequestTag[];
  /** @format date-time */
  time: string;
  timezone: string;
}

export interface RequestChangePasswordRequest {
  newPassword?: null | string;
  oldPassword?: null | string;
}

export interface RequestContentContentBookmarkedRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentContentEventRequest {
  /** @format int64 */
  contentId: number;
  entityId?: null | string;
  entityType?: null | string;
  eventType?: null | string;
  isRecommended?: null | boolean;
  metadata: RequestContentMetaDataRequest;
  platform?: null | string;
}

export interface RequestContentContentRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentDataRequest {
  key?: null | string;
  value?: null | string;
}

export interface RequestContentMetaDataRequest {
  data?: null | any[];
  section?: null | string;
  userAgent?: null | string;
  view?: null | string;
}

export interface RequestContentUpdateContentEngagementRequest {
  status?: null | string;
}

export interface RequestExchangeCodeForTokenRequest {
  code?: null | string;
  domain?: null | string;
  provider?: null | string;
  requestSource: ModelsRequestSource;
}

export interface RequestIdTokenRequest {
  idToken?: null | string;
  provider?: null | string;
}

/** Request object to authenticate user using login API */
export interface RequestLoginRequest {
  /**
   * @format password
   * @minLength 0
   * @maxLength 255
   */
  password: string;
  recaptchaToken?: null | string;
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
}

/**
 * The authorization code the realm delivered to the browser, and the PKCE verifier the browser
 * generated for that authorize request.
 */
export interface RequestPhaseTwoSessionRequest {
  /**
   * Authorization code from the realm's callback.
   * @minLength 1
   */
  code: string;
  /**
   * PKCE verifier matching the challenge sent on the authorize request.
   * @minLength 1
   */
  codeVerifier: string;
}

export interface RequestRefreshTokenRequest {
  token?: null | string;
}

export interface RequestRegisterUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  focusThemes?: null | any[];
  hasDeskJob?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  redirectUri?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestResetPasswordRequest {
  code?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  /** Email */
  userId?: null | string;
}

export interface RequestSendPasswordResetEmailRequest {
  email?: null | string;
  recaptchaToken?: null | string;
  redirectUrl?: null | string;
}

export interface RequestTag {
  description?: null | string;
  tagName?: null | string;
  tagType?: null | string;
  translations?: null | any[];
}

export interface RequestUpdatePhoneNumberRequest {
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  number: string;
}

export interface RequestUpdateUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  hasDeskJob?: null | boolean;
  isAiPersonalisedRecommendationsEnabled?: null | boolean;
  isManager?: null | boolean;
  isPartner?: null | boolean;
  isTranscriptionAllowed?: null | boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  signUpToNewsletter: boolean;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestUpdateVideoLanguageRequest {
  /** The dub the player starts on; null when the viewer never picked one. */
  audioLanguage?: null | string;
  /** The subtitles the player turns on; empty when the viewer turned them off, null when they never picked. */
  subtitleLanguage?: null | string;
}

export interface RequestUserConfirmationSignature {
  signature?: null | string;
}

export interface RequestUsersCheckPasswordStrengthRequest {
  password?: null | string;
}

export interface RequestUsersOtpLoginRequest {
  email?: null | string;
  password?: null | string;
}

export interface ResponseContentsArticleAudioFileResponse {
  playlistUrl?: null | string;
  timingUrl?: null | string;
  voiceName?: null | string;
}

export interface ResponseContentsArticleContentResponse {
  contents?: null | any[];
  cta?: null | string;
  isDownloadable: boolean;
  large?: null | string;
  medium?: null | string;
  src?: null | string;
  text?: null | string;
  textStyle?: null | string;
  thumbnail?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  variation?: null | string;
}

export interface ResponseContentsArticleResponse {
  aiSummary?: null | string;
  audioFiles?: null | any[];
  authors?: null | any[];
  contents?: null | any[];
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked: boolean;
  /** @format date-time */
  modifiedAt?: null | string;
  reviewer?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponse {
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  contentGroups: string[];
  coverImage?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  language: string;
  themes: string[];
  title: string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponsePaginated {
  data: ResponseContentsAudioContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsBookmarkContentResponse {
  /** @format int64 */
  contentId: number;
  isBookmarked: boolean;
}

/** Shared author representation for content responses (article, audio, video playback manifest). */
export interface ResponseContentsContentAuthorResponse {
  avatarUrl?: null | string;
  name?: null | string;
}

export interface ResponseContentsContentAutocompleteResponses {
  autocompleteTerms?: null | any[];
}

export interface ResponseContentsContentResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  orientation?: null | string;
  /**
   * @deprecated
   * @format int32
   */
  readTime: number;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  videoFormat?: null | string;
}

export interface ResponseContentsContentResponsePaginated {
  data: ResponseContentsContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsCourseResponse {
  coverImage: ResponseCoverImageResponse;
  description?: null | string;
  /** @format int32 */
  duration: number;
  /** @format int64 */
  id: number;
  learningGoals?: null | any[];
  lessons?: null | any[];
  themes?: null | any[];
  title?: null | string;
}

export interface ResponseContentsLessonResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format int32 */
  duration: number;
  engagementStatus?: null | string;
  /** @format int64 */
  id: number;
  introduction: ResponseContentsLessonResponseLessonIntroduction;
  /** @format int32 */
  lessonNo: number;
  title?: null | string;
  type?: null | string;
}

export interface ResponseContentsLessonResponseLessonIntroduction {
  description?: null | string;
  heading?: null | string;
  image: ResponseCoverImageResponse;
}

export interface ResponseContentsManagerMixedContentResponse {
  contents?: null | any[];
}

export interface ResponseContentsMixedContentResponse {
  contentCustomizedForUser: boolean;
  contents?: null | any[];
}

export interface ResponseContentsPlaybackManifestAudioResponse {
  language: string;
  url: string;
}

export interface ResponseContentsPlaybackManifestResponse {
  audio: ResponseContentsPlaybackManifestAudioResponse[];
  audioPlaylistUrl?: null | string;
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  /** @format int64 */
  contentId: number;
  coverImages?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  orientation?: null | string;
  subtitles: ResponseContentsPlaybackManifestSubtitleResponse[];
  title: string;
  transcripts: ResponseContentsPlaybackManifestTranscriptResponse[];
  videoFormat?: null | string;
  videoPlaylistUrl?: null | string;
}

export interface ResponseContentsPlaybackManifestSubtitleResponse {
  language: string;
  url: string;
}

export interface ResponseContentsPlaybackManifestTranscriptResponse {
  language: string;
  url: string;
}

export interface ResponseContentsUpdateContentEngagementResponse {
  /** @format int64 */
  contentId: number;
  contentType?: null | string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: null | string;
  status?: null | string;
}

export interface ResponseContentsVideoResponse {
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  languageCode: string;
  nativeUrl: string;
  orientation?: null | string;
  themes: string[];
  thumbnailPath: string;
  title: string;
  url: string;
  videoFormat?: null | string;
}

export interface ResponseCoverImageResponse {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

export interface ResponseCreateUnconfirmedUserResponse {
  signature?: null | string;
  unconfirmedDataId?: null | string;
}

export interface ResponseExternalLoginRegisterCodeFlowResponse {
  twoFactorVerification?: null | string;
  userId?: null | string;
  userTokenProviders?: null | any[];
}

export interface ResponseGroupedSearchResponse {
  /** In display order (the configured tab order, All first by default). The top result is not repeated in its group or in All. */
  groups: ResponseSearchGroupResponse[];
  topResult?: ResponseSearchResultItemResponse | null;
}

export interface ResponseLoginCodeFlowResponse {
  twoFactorVerification?: null | string;
  userId?: null | string;
  userTokenProviders?: null | any[];
}

export interface ResponseLogoutResponse {
  federatedLogoutUrl?: null | string;
}

/** @format int32 */
export enum ResponseOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Psychologist = "Psychologist",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ResponsePagination {
  /** @format int32 */
  currentPage: number;
  hasNextPage: boolean;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  total: number;
}

export interface ResponsePhaseTwoPasswordStatusResponse {
  hasPassword: boolean;
}

/** One window of a search group, plus what the client needs to ask for the next one. */
export interface ResponseSearchGroupPageResponse {
  /** True while the cached group holds more items past this window. */
  hasMore: boolean;
  items: ResponseSearchResultItemResponse[];
  /**
   * Echo of the requested page size.
   * @format int32
   */
  limit: number;
  /**
   * Echo of the requested offset.
   * @format int32
   */
  offset: number;
  /**
   * All matches in the group, which can exceed what is pageable.
   * @format int32
   */
  total: number;
}

export interface ResponseSearchGroupResponse {
  items: ResponseSearchResultItemResponse[];
  /** @format int32 */
  total: number;
  type: string;
}

export interface ResponseSearchResultItemResponse {
  /** @format int32 */
  durationInSeconds?: null | number;
  /** Spaces only: the event type's display name, for example "Group session". */
  eventType?: null | string;
  id: string;
  isBookable?: null | boolean;
  isShort: boolean;
  /**
   * Spaces only: when the next session starts (ISO 8601), or null when none is scheduled.
   * @format date-time
   */
  nextSessionAt?: null | string;
  personalUrlHandle?: null | string;
  position?: null | string;
  tags: string[];
  thumbnailUrl?: null | string;
  title: string;
  type: string;
  url?: null | string;
}

export interface ResponseTwoFactorNotEnforcedConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientEmail?: null | string;
  clientFirstName?: null | string;
  clientId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultType?: null | string;
  employeeFullName?: null | string;
  employeeId?: null | string;
  employeeImageUrl?: null | string;
  /** @format int32 */
  employeeNumber: number;
  employeePersonalUrlHandle?: null | string;
  employeeThumbnailUrl?: null | string;
  /** @format int32 */
  id: number;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
}

export interface ResponseUserPreferenceResponse {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export interface ResponseUserResponse {
  /** @format date-time */
  createdAt: string;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  employerName?: null | string;
  firstName?: null | string;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  id?: null | string;
  /**
   * Whether AI personalised recommendations are enabled for the user.
   * Read from the AI_PREFERENCES / aiPersonalisedRecommendations preference; null when the user has never
   * saved one. The profile page shows null as ticked; the AI coach asks for consent while it is null (AI-438).
   */
  isAiPersonalisedRecommendationsEnabled?: null | boolean;
  isEmailConfirmed: boolean;
  isFocusThemeSet: boolean;
  isGuestLogin: boolean;
  isManager: boolean;
  isPartner: boolean;
  isRegistered: boolean;
  isRegisteredWithPassword: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  loginProvider?: null | string;
  phoneNumber?: null | string;
  phoneNumberConfirmed: boolean;
  preferences?: null | any[];
  /**
   * True when the signed-in user must finish their profile in the register-app (terms not accepted yet).
   * Computed on the profile read and the update response only; false in the staff responses that embed this type.
   */
  requiresProfileCompletion: boolean;
  roles?: null | any[];
  signUpToNewsletter: boolean;
  twoFactorEnabled: boolean;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: null | any[];
  videoAudio?: null | string;
  videoSubtitle?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface SearchFaqParams {
  /** The user's question, used for semantic vector matching against the FAQ index. */
  question?: string;
}

export interface SearchGroupParams {
  /** Optional audience filter. */
  audience?: string;
  /** Locale to search in, e.g. en-GB. Required: a null value reaches Split('-') downstream. */
  languageCode: string;
  /**
   * Items to return, 1 to 50.
   * @format int32
   * @min 1
   * @max 50
   * @default 9
   */
  limit?: number;
  /**
   * How many items of this group the client already shows.
   * @format int32
   * @min 0
   * @max 49
   * @default 0
   */
  offset?: number;
  /**
   * The user's search term. Capped so an unbounded term cannot reach the index or the cache key.
   * @maxLength 200
   */
  searchTerm: string;
  /**
   * Group to page: all, articles, videos, shorts, audio, spaces or experts. Nullable so that an absent or
   * unparseable value fails model validation with a 400 — a non-nullable enum would silently bind to
   * the first member and page the wrong group.
   */
  type: ModelsDtosSearchSearchResultType;
}

export interface SearchParams {
  /** Optional audience filter. */
  audience?: string;
  /** Locale to search in, e.g. en-GB. Required: a null value reaches Split('-') downstream. */
  languageCode: string;
  /**
   * Items per group: 2 for the search modal, 9 for the results page.
   * @format int32
   * @min 1
   * @max 50
   * @default 9
   */
  limit?: number;
  /**
   * The user's search term. Capped so an unbounded term cannot reach the index or the cache key.
   * @maxLength 200
   */
  searchTerm: string;
}

export interface SearchV2Params {
  audience?: string;
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm: string;
  /** @default 0 */
  shortsMode?: ModelsDtosShortsMode;
  types?: string[];
}

export interface SendEmailVerificationParams {
  /** The email address to which this verification link will be sent */
  email?: string;
  /** The Uri where user should be redirected after verification of the email address */
  redirectUri?: string;
}

export type SetUserCurrentMoodsPayload = string[];

export type SetUserPreferencesPayload = ModelsUserPreference[];
